/** Labels de sub_tipo — manter alinhado a mobile/src/api/milhas.ts (SUB_TIPO_LABELS). */
export const SUB_TIPO_LABELS = {
    COMPRA_BONIFICADA: 'Compra Bonificada',
    COMPRA_PONTOS: 'Compra de Pontos',
    PONTOS_CARTAO: 'Pontos de Cartão',
    BONUS_RECEBIDOS: 'Bônus Recebidos',
    ENTRADA_AVULSA: 'Entrada Avulsa',
    SAIDA_AVULSA: 'Saída Avulsa',
    SAIDA_VENDA_MILHAS: 'Débito por Venda',
    DEBITO_TRANSFERENCIA: 'Débito por Transferência',
    EXPIRACAO: 'Expiração',
    BONUS_CLUBE: 'Bônus de Clube',
    PONTOS_CLUBE: 'Pontos de Clube',
    BONUS_TRANSFERENCIA: 'Bônus de Transferência',
    CREDITO_TRANSFERENCIA: 'Crédito de Transferência',
    TRANSFERENCIA_TERCEIROS_CEDIDA: 'Transf. Terceiro (Saída)',
    TRANSFERENCIA_TERCEIROS_RECEBIDA: 'Transf. Terceiro (Entrada)',
    ESTORNO_CANCELAMENTO: 'Estorno de Cancelamento',
};

export function subTipoLabel(subTipo) {
    if (!subTipo) return 'Movimentação';
    return SUB_TIPO_LABELS[subTipo] || String(subTipo).replace(/_/g, ' ');
}

export function operacaoLabel(transacao) {
    if (transacao?.status === 'PROJETADA' && transacao?.projecao_info?.descricao) {
        return String(transacao.projecao_info.descricao);
    }
    return subTipoLabel(transacao?.sub_tipo);
}

export const STATUS_MILHAS_LABELS = {
    PENDENTE: 'Pendente',
    CONCLUIDA: 'Concluída',
    PROJETADA: 'Projetada',
};

export function isMilhasAReceber(t) {
    return (
        t?.tipo_transacao === 'ENTRADA' &&
        (t?.status === 'PENDENTE' || t?.status === 'PROJETADA')
    );
}
